export default class FeatureFlag {
    name: string
    value: any

    constructor(name: string, value: any) {
        this.name = name
        this.value = value
    }

    getName(): string {
        return this.name;
    }

    isEnabled(): boolean {
        return this.value;
    }
}


export class AlwaysEnabledFeatureFlag extends FeatureFlag {
    constructor() {
        super("always_enabled_feature_flag", true)
    }
}

export class AlwaysDisabledFeatureFlag extends FeatureFlag {
    constructor() {
        super("always_disabled_feature_flag", false)
    }
}
